import { z } from 'zod';
export var ProgramResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('program')
});
export var Program = z.object({
  id: z.string(),
  name: z.string(),
  deliveryMethod: z.string(),
  level: z.string(),
  levelText: z.string(),
  schoolId: z.number(),
  published: z["boolean"]().optional(),
  submissionMethod: z.string().nullish(),
  requiredLevel: z.string().nullish(),
  slug: z.string()
});
/**
 * If there is no ESL program associated with the application, but there is an
 * ESL program associated with the academic program, this object represents the
 * ESL program the user is allowed to add to the application
 */
export var ExpectedEslProgramResponse = z.object({
  type: z.literal('expected_esl_program'),
  id: z.string()
});